import { Navigate } from 'react-router-dom'

// «Следующий шаг» merged into «Путь» (boards ccd73u7xtwif6iczp76zd3xjb5r):
// old /next-step links — bookmarks, cached screens — land on the merged screen.
export default function LegacyNextStepRedirect() {
  return <Navigate to="/progress" replace />
}
